import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Canonical = () => {
  const location = useLocation();
  const canonicalUrl = `https://mean3.com${location.pathname}`;

  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");

    if (!link) {
      // Create link if it doesn't exist
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.prepend(link); // PREPEND at start of head
    }

    // Update the href for current page
    link.setAttribute("href", canonicalUrl);
  }, [canonicalUrl]);

  return null;
};

export default Canonical;
